export const FETCH_LEADERBOARD = 'leaderboard/fetchLeaderboard';
export const LEADERBOARD_TIMEOUT = 'leaderboard/leaderboardTimeout';
